import { SubProductsState } from "../types/state";

export const subProductsInitialState: SubProductsState = {
    tableIds: [],
    tables: {},

    shownTableId: "",
    tempShownTable: {},

    readOnlyMode: false,
    groupingMode: false,

    modalIds: [],
    modals: {},

    locale: "en",
};
